module.exports = __webpack_public_path__ + "static/media/icn_ui_arrow_right.94f7bc44.svg";